module.exports = __webpack_public_path__ + "img/rowed.889c0af4.png";